import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=3f2d5b96&scoped=true&"
import script from "./DialogComponent.vue?vue&type=script&lang=ts&"
export * from "./DialogComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=3f2d5b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d5b96",
  null
  
)

export default component.exports